import type { JSX } from 'react';
import { useCallback } from 'react';
import { useAlert } from '../Modal/Alert';

type Props = {
  onDelete: () => void;
  message?: string;
};

const defaultMessage = 'Deleting a tag is irreversible and removes tagged data from transcripts.';

export const useDeleteTagModal = ({ onDelete, message = defaultMessage }: Props): [() => void, () => JSX.Element] => {
  const [toggleDeleteAlert, DeleteAlert] = useAlert();

  const DeleteTagModal = useCallback((): JSX.Element => {
    return (
      <DeleteAlert
        message={message}
        onConfirm={onDelete}
      />
    );
  }, [DeleteAlert, onDelete, message]);

  return [toggleDeleteAlert, DeleteTagModal];
};
